import PropTypes from "prop-types";
import React from "react";
import CallToAction from "../CallToAction";
import lodash from "lodash";

const HRAResults = ({
  data,
  isForEnrolment,
  isShopEnabled,
  isEnrolmentEnabled,
  isHraEnabled,
  client,
}) => {
  // Temp solution to prevent showing new HRA widget implemation to BUPA
  if (client === "bupa") {
    return null;
  }

  if (isForEnrolment && !isEnrolmentEnabled) {
    return null;
  }

  const { results } = data;
  const isHraQuestionsAnswered =
    !lodash.isEmpty(results) &&
    results.assessmentStatus.hraQuestionsAnswered === "true";

  if (isHraEnabled && !isHraQuestionsAnswered) {
    return (
      <CallToAction
        isShopEnabled={isShopEnabled}
        isForEnrolment={isForEnrolment}
        key={"HRACallToAction"}
      />
    );
  }

  return null;
};

HRAResults.propTypes = {
  data: PropTypes.shape({
    results: PropTypes.object.isRequired,
  }),
  isForEnrolment: PropTypes.bool,
  isShopEnabled: PropTypes.bool,
  isEnrolmentEnabled: PropTypes.bool,
  isHraEnabled: PropTypes.bool,
  client: PropTypes.string,
};

export default HRAResults;



// WEBPACK FOOTER //
// ./components/dashboard/widgets/HRACallToAction.js